import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { BlockJustify } from '../../../../models/BlockSettings';

interface BlockJustifyPickerProps {
  value: BlockJustify;
  direction: 'row' | 'column';
  onChangeJustify: (value: BlockJustify) => void;
}

const BlockJustifyPicker = ({ value, direction, onChangeJustify }: BlockJustifyPickerProps) => (
  <Box>
    { direction === 'column' ? '垂直方向の位置' : '水平方向の位置'}
    <ToggleButtonGroup
      color="primary"
      value={value}
      exclusive
      onChange={(_, newValue: BlockJustify) => {
        if (newValue) {
          onChangeJustify(newValue);
        }
      }}
      size="small"
      sx={{ marginLeft: 3 }}
    >
      <ToggleButton value={BlockJustify.START} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? '上揃え' : '左寄せ'}</ToggleButton>
      <ToggleButton value={BlockJustify.CENTER} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? '中央揃え' : '中央'}</ToggleButton>
      <ToggleButton value={BlockJustify.END} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? '下揃え' : '右寄せ'}</ToggleButton>
      <ToggleButton value={BlockJustify.SPACE_BETWEEN} sx={{ paddingX: 2, paddingY: 1 }}>均等配置（間）</ToggleButton>
      <ToggleButton value={BlockJustify.SPACE_AROUND} sx={{ paddingX: 2, paddingY: 1 }}>均等配置（周り）</ToggleButton>
      <ToggleButton value={BlockJustify.SPACE_EVENLY} sx={{ paddingX: 2, paddingY: 1 }}>均等配置（先頭末尾含む）</ToggleButton>
    </ToggleButtonGroup>
  </Box>
);

export default BlockJustifyPicker;
